import React from 'react'
import ReactDOM from 'react-dom/client'
import AttorneyApp from './AttorneyApp'
import '../index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AttorneyApp />
  </React.StrictMode>,
)
